// extracted by mini-css-extract-plugin
module.exports = {"button":"UploadLocalEntityButton_button__2x-VY","error":"UploadLocalEntityButton_error__32fbK"};